import { Component, OnInit, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { fadeInSlideFromDown, onMainContentChange } from '../service/animations';

import { Subscription, BehaviorSubject } from 'rxjs';
import { tap, debounceTime, distinctUntilChanged, filter, switchMap, map, skip } from 'rxjs/operators';

import { SearchFilterService } from '../service/search-filter.service';
import { ISearchResultModel } from '../models/search-result-model';
import { IToggleSingleFilter, IChangeManyFilterItems } from '../models/common-model';
import { ShortListService } from '../service/short-list.service';

// Third Party
import { PageChangedEvent } from 'ngx-bootstrap/pagination';

@Component({
  selector: 'lud-derivative-search-container',
  templateUrl: './derivative-search-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeInSlideFromDown(20), onMainContentChange]
})
export class DerivativeSearchContainerComponent implements OnInit, OnDestroy {

  derivativeSearchForm: FormGroup;

  totalItems$ = new BehaviorSubject(0);
  totalItemsPaging$ = new BehaviorSubject(0);
  itemsPerPage$ = new BehaviorSubject(null);
  isLoading$ = new BehaviorSubject(false);
  itemsToShow$ = new BehaviorSubject(null);
  filtersToShow$ = new BehaviorSubject([]);

  sideNavOpened$;// ToDo store state on destroy
  currentDsPeriod$;

  viewType: string = '';//'card' | 'list' | 'gantt' = 'list';

  private masterItemsToShow = [];

  private subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private searchfilterService: SearchFilterService,
    private shortListService: ShortListService
  ) {
    this.sideNavOpened$ = searchfilterService.sideNavState$;

    this.currentDsPeriod$ = searchfilterService.activeDsCurrentValue$;
  }

  ngOnInit() {
    //this.searchfilterService.reset();
    //this.shortListService.reset();

    this.subscriptions.push(
      this.shortListService.reset$
        .subscribe(result => {
          this.itemsToShow$.next(JSON.parse(JSON.stringify(this.masterItemsToShow)));
        })
    );

    var currentActiveFilter = this.searchfilterService.currentActive;

    this.derivativeSearchForm = this.fb.group({
      query: [currentActiveFilter.query, Validators.required]
    });

    this.subscriptions.push(
      this.searchfilterService.active$
        .pipe(
          //skip(1),
          switchMap(searchModel => {
            this.isLoading$.next(true);

            this.itemsPerPage$.next(searchModel.itemsPerPage);

            return this.searchfilterService.search(searchModel)
          }),
          tap((res: ISearchResultModel) => {
            this.isLoading$.next(false);

            this.totalItems$.next(res.totalItems);
            this.totalItemsPaging$.next(Math.min(res.totalItems, 10000));// Elastic Search limit to 10,000 pages
            this.masterItemsToShow = res.items;
            this.itemsToShow$.next(JSON.parse(JSON.stringify(res.items)));
            this.filtersToShow$.next(res.filters);
          })
        ).subscribe()
    );
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  searchQueryChanged(event: boolean) {
    this.searchfilterService.update(this.derivativeSearchForm.controls['query'].value);
  }

  filterSingleChanged(filter: IToggleSingleFilter) {
    this.searchfilterService.toggleFilter(filter);
  }
  filterManyChanged(filter: IChangeManyFilterItems) {
    this.searchfilterService.changeFilter(filter);
  }
  pageChanged(event: PageChangedEvent): void {
    //const startItem = (event.page - 1) * event.itemsPerPage;
    //const endItem = event.page * event.itemsPerPage;

    //console.log("event", event);
    this.searchfilterService.pageChanged(event.page);
  }

  resetFilters(event): void {
    this.searchfilterService.reset(false);
  }

  saveFilters(event): void {
    this.shortListService.addToBasketFilter({ ...this.searchfilterService.currentActive, query: this.derivativeSearchForm.controls['query'].value });
  }
}
